import React from 'react';
import ExampleNetwork from './queryArea/ExampleNetwork';
import NetworkName from './queryArea/NetworkName';
import CohortDiseaseName from './queryArea/CohortDiseaseName';
import SearchTags from './queryArea/SearchTags';
import EdgeSignificance from './queryArea/EdgeSignificance';
import NodeLimit from './queryArea/NodeLimit';
import Correlation from './queryArea/Correlation';
import IncludeNeighbourConnections from './queryArea/IncludeNeighbourConnections';
import Search from './queryArea/Search';

// https://react-hook-form.com/get-started/#IntegratingwithUIlibraries
const QueryArea = () => {
  return (
    <div>
      <ExampleNetwork />

      <NetworkName />

      <CohortDiseaseName />

      <SearchTags />

      <EdgeSignificance />

      <NodeLimit />

      <Correlation />

      <IncludeNeighbourConnections />

      <Search />
      <br />
    </div>
  );
};

export default QueryArea;
